<div class="modal-header d-flex justify-content-between" >
    <h4 class="modal-title"></h4>
    <p *ngIf="bsModalRef" (click)="bsModalRef.hide()" class="modal-clost-btn" aria-label="Close">&times;</p>
</div>
<div class="modal-body text-center">
  <h5 class="text-title">{{confirmQuestion}}</h5>
  <h5 class="text-title pb-5"><b>{{itemName}}</b></h5>
  <div [formGroup]="form" class="form-group" *ngIf="isDecline === true">
    <textarea  formControlName="declineReason" class="form-input form-control" id="" cols="30" rows="5"
      placeholder="Please provide a reason for the declination."></textarea>

  </div>
  <div class="mt-5 gap-2">
    
    <app-button (onclick)="onConfrim()"  primary class="me-2">
      <span >{{confirm&&confirm.loading ? "Loading..." : (confirm&&confirm.text || 'Confirm')}}</span>
    </app-button>
    <app-button (onclick)="bsModalRef? bsModalRef?.hide() : modalRef?.hide()" danger class="">Cancel</app-button>
  </div>
</div>
